<div class="widgets">
    <construction-tools></construction-tools>
</div>
